export default __webpack_public_path__ + "static/media/nistlogo.2e955d79.png";